import React from 'react';
import { VolumeCard } from '../VolumeCard';
import { SectionCTA } from '../SectionCTA';
import { volumes } from '../../data/volumes';
export function Volumes() {
  return <section className="bg-mist px-5 py-16 md:py-24" aria-labelledby="volumes-title" data-id="element-367" data-mp="2x19tiaut648g">
      <div className="mx-auto max-w-6xl" data-id="element-368" data-mp="2x34hjy1dmcgr">
        <p className="text-center font-display text-xs font-extrabold uppercase tracking-[0.14em] text-pulse sm:text-sm" data-id="element-369" data-mp="2t0g6djp6wtgm">
          What’s inside the ECG Interpretation Blueprint™?
        </p>
        <h2 id="volumes-title" className="mx-auto mt-3 max-w-4xl text-center font-display text-3xl font-black leading-tight text-navy-900 sm:text-5xl text-balance" data-id="element-370" data-mp="2j9lk4fby1tv6">
          Six Comprehensive Volumes to Organize Your ECG Interpretation Studies
        </h2>
        <p className="mx-auto mt-4 max-w-2xl text-center text-lg text-muted" data-id="element-371" data-mp="259u8umctarkv">
          From cardiac electrical fundamentals to simulated clinical interpretation exercises, each volume focuses on a
          specific area of learning.
        </p>

        <div className="mt-12 space-y-8" data-id="element-372" data-mp="3342up9efzqfk">
          {volumes.map(volume => <VolumeCard key={volume.numeral} volume={volume} data-id="element-373" data-mp="37x4gm1d2gq8n" />)}
        </div>

        <SectionCTA label="I want all 6 volumes for $27" data-id="element-374" data-mp="2u5zcalyr79rz" />
      </div>
    </section>;
}